module.exports = __webpack_public_path__ + "assets/fa5fe2088faecb1112ae8c844fb689c6.jpg";